const MIN_NUM_OF_CUSTOMERS = 100;

interface Props {
  numCustomers: number;
}

export default function TotalBookings({ numCustomers }: Props) {
  return numCustomers > MIN_NUM_OF_CUSTOMERS ? (
    <div>
      <b style={{ fontWeight: 700 }}>{numCustomers} people</b> already enjoyed
      this experience
    </div>
  ) : null;
}
